import { getMessages } from '../../../../../../store/constants';

export const WEBHOOKS_SECTION_TITLE = getMessages().getText('board_settings.webhooks.title');
